// extracted by mini-css-extract-plugin
module.exports = {"TableCell":"TableBudgetsAndReach_TableCell__r0OCD","tableCell":"TableBudgetsAndReach_TableCell__r0OCD"};